import { firestore } from "../firebase";
import { pad3 } from "./format";

// Atomically generate quote number for the current user.
export async function generateQuoteNumber({ userId, codePrefix }) {
  const countersRef = firestore.collection("counters").doc(userId);
  const now = new Date();
  const currentMM = String(now.getMonth() + 1).padStart(2, "0");

  const result = await firestore.runTransaction(async (tx) => {
    const snap = await tx.get(countersRef);
    let nextSequence = 1;
    let lastMonth = currentMM;
    if (snap.exists) {
      const data = snap.data();
      nextSequence = (data.nextSequence || 1);
      lastMonth = data.lastMonth || currentMM;
    }
    // Month tag updates but counter continues (no reset).
    tx.set(
      countersRef,
      { nextSequence: nextSequence + 1, lastMonth: currentMM },
      { merge: true }
    );
    const formatted = `${(codePrefix || "XX").toUpperCase()}-${currentMM}-${pad3(nextSequence)}`;
    return formatted;
  });

  return result;
}


